<template>
  <component
    :is="component"
    :api-route="apiRoute"
    :course-id="courseId"
    :subscribable-grouping-id="subscribableGroupingId"
    :type="type"
  />
</template>

<script>
import { APPOINTMENT, COURSE, EXAM, GROUP, SINGLE } from '@/constants'
import CourseSubscriptionsMatrixOverview from '@/employees/components/Subscribable/CourseSubscriptionsMatrixOverview'
import ExamSubscriptionsMatrixOverview from '@/employees/components/Subscribable/ExamSubscriptionsMatrixOverview'
import GroupSubscriptionsMatrixOverview from '@/employees/components/Subscribable/GroupSubscriptionsMatrixOverview'
import SingleSubscriptionsMatrixOverview from '@/employees/components/Subscribable/SingleSubscriptionsMatrixOverview'

export default {
  name: 'GeneralSubscriptionsMatrixOverview',

  components: { CourseSubscriptionsMatrixOverview, ExamSubscriptionsMatrixOverview, GroupSubscriptionsMatrixOverview, SingleSubscriptionsMatrixOverview },

  props: {
    apiRoute: {
      required: true,
      type: String,
    },
    courseId: {
      required: false,
      type: String,
      default: null,
    },
    subscribableGroupingId: {
      required: false,
      type: String,
      default: null,
    },
    type: {
      required: true,
      type: String,
    },
  },

  data () {
    return {
      courseType: COURSE,
      examType: EXAM,
      groupType: GROUP,
      singleType: SINGLE,
    }
  },

  computed: {
    component () {
      switch (this.type) {
        case APPOINTMENT:
        case SINGLE:
          return SingleSubscriptionsMatrixOverview
        case GROUP:
          return GroupSubscriptionsMatrixOverview
        case EXAM:
          return ExamSubscriptionsMatrixOverview
        case COURSE:
          return CourseSubscriptionsMatrixOverview
        default:
          throw new Error('Unknown subscribable Type')
      }
    },
  },
}
</script>

<style lang="scss">

</style>
